import axios from "axios";
import Cookies from "cookie-universal";

export const baseUrl = "https://jobaacademy.com";
const cookie = Cookies();

export const Axios = axios.create({
  baseURL: "https://jobaacademy.com/api",
});

Axios.interceptors.request.use((config) => {
  const token = cookie.get("token");

  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }

  if (config.data instanceof FormData) {
    config.headers["Content-Type"] = "multipart/form-data";
  } else {
    config.headers["Content-Type"] = "application/json";
  }

  return config;
});
